export const APP_CACHE = 'app-cache';
export const DASHBOARD_UX = 'dashboard_ux';
export const ONBOARDING_STATE = 'onboarding_state';
export const PORTAL_HISTORY = 'portal_history';
